import React, { useEffect, useState } from "react";
import { RootState, useAppDispatch } from "../../../app/features/store/store";
import { toast } from "react-toastify";
import { updateUserTokenToInvalid } from "../../../app/features/login/loginSlice";
import getAxiosError from "../../../app/api/axiosError";
import SubmitModal from "../../../components/common/modalPopup/SubmitModal";
import { Box, Grid, MenuItem, TextField } from "@mui/material";
import { AddZipCoverageRequest } from "../../../app/models/requestModels/zipCoverageRequest";
import { addZipCoverage } from "../../../app/features/zipCoverage/zipCoverageSlice";
import { useSelector } from "react-redux";
import Loader from "../../../components/common/loader/Loader";
import { getparcelCenterList } from "../../../app/features/parcelCenter/parcelCenterSlice";

interface AddZipCoverageModalProps {
  closeAddZipCoverageModal: CallableFunction;
  onCompleted: CallableFunction;
}

function AddZipCoverageModel(
  parcelCenterId: string,
  zipCode: string
): AddZipCoverageRequest {
  return {
    parcelCenterId: parcelCenterId,
    zipCode: zipCode,
  };
}

const AddZipCoverageModal = ({
  closeAddZipCoverageModal,
  onCompleted,
}: AddZipCoverageModalProps) => {
  const dispatch = useAppDispatch();

  const { isLoading: isParcelCenterListLoading, parcelCenterList } =
    useSelector((state: RootState) => state.parcelCenter);

  const [selectedParcelCenterId, setSelectedParcelCenterId] = useState("");

  const handleParcelCenterChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    let selectedOption = event.target.value as string;
    setSelectedParcelCenterId(selectedOption);
  };

  // ***** States *****
  // const [parcelCenterId, setParcelCenterId] = useState("");
  const [zipCode, setZipCode] = useState("");

  // ***** Handlers *****
  const handleSubmit = async () => {
    try {
      if (selectedParcelCenterId.length === 0) {
        toast.error("parcel center is required");
        return false;
      }
      if (zipCode.length === 0) {
        toast.error("Zip Code is required");
        return false;
      }
      const model = AddZipCoverageModel(selectedParcelCenterId, zipCode);
      const response = await dispatch(addZipCoverage(model)).unwrap();
      if (response.isSuccess) {
        toast.success(response.message!, {
          toastId: "addZipCoverageSuccess",
        });
        onCompleted();
      } else {
        toast.error(response.message!, {
          toastId: "addZipCoverageError",
        });
      }
    } catch (error) {
      const appError = getAxiosError(error);
      toast.error(appError.errorMessage, {
        toastId: "addZipCoverageException",
      });
    }
    return true;
  };

  useEffect(() => {
    let isFunctionRan = true;
    const getParcelCenterData = async () => {
      try {
        const response = await dispatch(getparcelCenterList()).unwrap();
        if (!response.isSuccess) {
          toast.error(response.message!, {
            toastId: "parcelCenterList",
          });
        }
      } catch (error) {
        const appError = getAxiosError(error);
        toast.error(appError.errorMessage, {
          toastId: "parcelCenterListException",
        });
      }
    };

    if (isFunctionRan) {
      getParcelCenterData();
    }

    return () => {
      isFunctionRan = false;
    };
  }, [dispatch]);

  return (
    <>
      <SubmitModal
        title="Add Zip Coverage"
        asyncOperation={handleSubmit}
        closeSubmitModal={closeAddZipCoverageModal}
        allowSubmit={true}
        size="lg"
        isLoading={false}
        submitButtonName="Save"
        closeModalAfterSubmit={true}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Grid container rowSpacing={2} columnSpacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              {isParcelCenterListLoading ? (
                <Loader isLoading={isParcelCenterListLoading} />
              ) : (
                <TextField
                  select
                  margin="normal"
                  id="parcelCenter"
                  label="Parcel Center"
                  name="parcelCenter"
                  size="small"
                  fullWidth
                  required
                  value={selectedParcelCenterId}
                  onChange={handleParcelCenterChange}
                >
                  {parcelCenterList.map((Option, index) => (
                    <MenuItem
                      value={Option.parcelCenterId}
                      key={Option.parcelCenterId}
                    >
                      {Option.parcelCenterName}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <TextField
                margin="normal"
                id="zipCode"
                label="Zip Code"
                name="zipCode"
                size="small"
                fullWidth
                value={zipCode}
                onChange={(event) => setZipCode(event.target.value)}
              />
            </Grid>
          </Grid>
        </Box>
      </SubmitModal>
    </>
  );
};

export default AddZipCoverageModal;
